import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GenericFormService } from '../service/generic-form.service';
import { FormControl } from '@angular/forms';
import { FieldModel } from '../model/field.model';
import { ObjectUtils } from '@cv-invision/core';
import { mismatchValidatorOld } from '../validators/mismatch.validator';

@Component({
	selector: 'cv-password-field',
	templateUrl: './password-field.component.html',
	styleUrls: ['./password-field.component.scss'],
})
export class PasswordFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	@Input() show: any;
	@Input() active = false;

	@ViewChild('changesEl', { read: ElementRef, static: false }) changesEl: ElementRef;

	validPassword: boolean;
	focusField: boolean;
	minLength = 6;
	maxLength = 12;

	get strongRegexp(): string {
		return `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{${this.minLength},${this.maxLength}})(?=.*[\`!@#$%^&*()_+-=[\\]{};':"|,.<>\\/?~])`;
	}

	/**
	 * ToDo: read the field metadata to get the min & max length from the options
	 */
	get validLength(): boolean {
		return this.control.value?.length >= this.minLength && this.control.value?.length <= this.maxLength;
	}

	get hasNumberCharacter(): boolean {
		return ObjectUtils.hasNumberCharacter(this.control.value);
	}

	get hasUpperCase(): boolean {
		return ObjectUtils.hasUppercaseCharacter(this.control.value || '');
	}

	get hasSpecialCharacter(): boolean {
		return ObjectUtils.hasSpecialCharacter(this.control.value);
	}

	constructor(
		private formService: GenericFormService
	) {
		this.validPassword = false;
		this.focusField = false;
	}

	ngOnInit(): any {
		if (this.field.disabled) {
			this.control.disable();
		}

		if (this.field.UIOptions?.validators) {
			(this.field.UIOptions?.validators || []).forEach(validator => {
				const minMaxReg = /(min|max)gm/
				const exists = minMaxReg.test(validator);
				if (exists) {
					const validatorParts = (validator || '').split(':');
					switch(exists[0]) {
						case 'min': this.minLength = validatorParts[1]; break;
						case 'max': this.maxLength = validatorParts[1]; break;
					}
				}
			});
		}
	}

	/**
	 * validates form on input blur
	 * @param event
	 */
	async onChange(event: any): Promise<void> {
		if (this.field?.UIEvents?.onChangeText) {
			this.formService.onChangeText$.next({
				field: this.field,
				fieldOptions: this.fieldOptions,
				event: {
					eventName: 'onChangeText',
					data: this.control.value
				}
			});
		}
	}

	/**
	 * validates form on input keyup
	 * @param event
	 */
	async onKeyup(event: any): Promise<void> {
		if (this.control.parent) {
			if (this.control.dirty) {
				this.formService.validate(this.control);
			}
		}
	}

	onBlurField($event): void {
		this.focusField = false;
	}

	onFocus($event): void {
		this.focusField = true;
	}

	/**
	 * ToDo: read the field metadata to get the min & max length from the options
	 */
	onPasswordValidation(event: any) {
		const pattern = `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{${this.minLength},${this.maxLength}})(?=.*[\`!@#$%^&*()_+-=[\\]{};':"|,.<>\\/?~])`;
		const regex = new RegExp(pattern);

		this.validPassword = regex.test(this.control.value) && this.validLength;
	}
}
